import moment from 'moment';
import { ruleExtension } from '../Mentainance';

export interface MaintenanceValidationError {
  maintenanceStartValidationMessage?: string;
  maintenanceEndValidationMessage?: string;
  maintenanceRepeatValidationMessage?: string;
}

export const validateMaintenanceRule = (rule: ruleExtension): MaintenanceValidationError => {
  const errors: MaintenanceValidationError = {};

  if (!rule.maintenanceStartTime) {
    errors.maintenanceStartValidationMessage = 'Please select a maintenance start time';
    return errors;
  }

  if (!rule.maintenanceStartDate) {
    errors.maintenanceStartValidationMessage = 'Please select a maintenance start date';
    return errors;
  }

  if (
    (rule.maintenanceEndDate && !rule.maintenanceEndTime) ||
    (!rule.maintenanceEndDate && rule.maintenanceEndTime)
  ) {
    errors.maintenanceEndValidationMessage = `Please select a maintenance end ${
      rule.maintenanceEndDate ? 'time' : 'date'
    }`;
    return errors;
  }

  const maintenanceStartDateWithTime = moment(rule.maintenanceStartDate).add(
    rule.maintenanceStartTime || '00:00',
    'hours',
  );

  const maintenanceEndDateWithTime = rule.maintenanceEndDate
    ? moment(rule.maintenanceEndDate).add(rule.maintenanceEndTime || '00:00', 'hours')
    : null;
  const repeatTill = rule.repeatTill ? moment(rule.repeatTill) : null;
  const maintenanceEndIsBeforeStart =
    new Date(rule.maintenanceEndDate ? rule.maintenanceEndDate : '') <
    new Date(rule.maintenanceStartDate);

  if (maintenanceEndDateWithTime) {
    if (maintenanceEndDateWithTime.isBefore(moment())) {
      errors.maintenanceEndValidationMessage = 'Maintenance end date should be a future date';
      return errors;
    }
    if (
      rule.maintenanceEndDate &&
      moment(rule.maintenanceEndDate).isBefore(rule.maintenanceStartDate)
    ) {
      errors.maintenanceEndValidationMessage = 'End date cannot be before start date';
      return errors;
    }
    if (maintenanceStartDateWithTime.isSame(maintenanceEndDateWithTime)) {
      errors.maintenanceEndValidationMessage = 'End time cannot be same as start time';
      return errors;
    }

    if (maintenanceEndIsBeforeStart) {
      errors.maintenanceEndValidationMessage = 'End time cannot be before start time';
      return errors;
    }

    if (rule.repetition && repeatTill) {
      if (
        repeatTill.isBefore(moment()) ||
        (rule.repeatButton ? repeatTill.isBefore(maintenanceEndDateWithTime) : false)
      ) {
        errors.maintenanceRepeatValidationMessage =
          'Maintenance Repeat date should be a future date';
        return errors;
      }
    }
  }

  return errors;
};
